import React, { Fragment } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import SideContact from './components/SideContact';
import Main from './components/Main';

function App() {
  return (
    <Fragment>
      <Header />
      <Main />
      <Footer />
      <SideContact />
    </Fragment>
  );
}

export default App;
